export default "__VITE_ASSET__BK26lZ2z__"